import { render } from "./CalendarEventOfferSelectionModal.vue?vue&type=template&id=50550796&scoped=true"
import script from "./CalendarEventOfferSelectionModal.vue?vue&type=script&lang=ts"
export * from "./CalendarEventOfferSelectionModal.vue?vue&type=script&lang=ts"

import "./CalendarEventOfferSelectionModal.vue?vue&type=style&index=0&id=50550796&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50550796"

export default script